<template>
  <div class="fontpicker" :tabindex="tabindex" @blur="open = false">
    <div class="selected" :class="{ open: open }" @click="open = !open" :style="fontStyles(selected.value.family, selected.value.weight)">
      {{ selected.text }}
    </div>
    <div class="options" :class="{ selectHide: !open }">
      <div
        v-for="(font, i) of fonts"
        :key="i"
        @click="
          selected = font;
          open = false;
          $emit('input', font);
        "
        :style="fontStyles(font.value.family, font.value.weight)"
      >
        {{ font.text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fonts: {
      type: Array,
      required: true,
    },
    default: {
      type: String,
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      selected: this.fonts[0],
      open: false,
    };
  },
  methods: {
    fontStyles(family, weight) {
      return `font-family: ${family}; font-weight: ${weight}`;
    }
  },
  mounted() {
    this.$emit("input", this.selected);
  },
};
</script>
